import { PageSectionsContentSectionContentBlocksImageInformationCardListInformationCards } from '@/tina/__generated__/types';
import * as stylex from '@stylexjs/stylex';
import Image from 'next/image';
import { tinaField } from 'tinacms/dist/react';
import { layout } from '../styles/layout';
import '../styles/tokens.stylex';
import { borderRadius, spacing } from '../styles/tokens.stylex';
import { typography } from '../styles/typography';
import { RichText } from './RichText';
export interface InfoCardProps {
  data?: PageSectionsContentSectionContentBlocksImageInformationCardListInformationCards;
  cardVariant?: 'regularWithImage' | 'largeWithImage';
}
export function InfoCard({
  data,
  cardVariant = 'regularWithImage'
}: InfoCardProps) {
  return data ? <li {...stylex.props(layout.contentCard, sx.listItem, cardVariant === 'largeWithImage' && largeCardStyles.listItem, !data.image && sx.textOnlyStyles)}>
      <div {...{
      0: {
        className: "xrvj5dj x1y6fwsi x1clt5hq xudgm0i x1o4oh2x x1oibge4 xdnt9b6 xtq63kg x8xksj8 x1qsyu4 x105j67a xvw2azv xb53741"
      },
      1: {
        className: "xrvj5dj x1y6fwsi xudgm0i xamitd3 x1tu4anv x1o4oh2x x1rsck06 x1oibge4 x1858hps x1qsyu4 x1wvwou2"
      }
    }[!!(cardVariant === 'largeWithImage') << 0]}>
        <h2 {...stylex.props(cardVariant === 'largeWithImage' ? typography.heading2 : typography.heading3)} data-tina-field={tinaField(data, 'heading')}>
          {data?.heading}
        </h2>
        <div data-tina-field={tinaField(data, 'text')}>
          <RichText>{data?.text}</RichText>
        </div>
      </div>
      {data?.image && <div {...{
      0: {
        className: "x1n2onr6 x1ficeh5 x1oibge4 x1nbmu9y xtq63kg x1g4vh7l x1ms6mhf x105j67a x1gq4icj xb53741"
      },
      2: {
        className: "x1n2onr6 x1dby22o x17he1k x1oibge4 xtx6t72 x1ms6mhf x1wvwou2"
      },
      1: {
        className: "x1n2onr6 x1ficeh5 x1oibge4 x1nbmu9y xtq63kg x1g4vh7l x1ms6mhf x105j67a x1gq4icj xb53741 x99ko0r"
      },
      3: {
        className: "x1n2onr6 x1dby22o x17he1k x1oibge4 xtx6t72 x1ms6mhf x1wvwou2 x99ko0r"
      }
    }[!!(cardVariant === 'largeWithImage') << 1 | !!(data.imageFit === 'contain') << 0]} data-tina-field={tinaField(data, 'image')}>
          <Image fill sizes="100vw, (min-width: 800px) 400px" src={data.image} alt={data.alt as string} {...{
        0: {
          className: "xl1xv1r"
        },
        1: {
          className: "x19kjcj4 x5yyhv"
        }
      }[!!(data.imageFit === 'contain') << 0]} />
        </div>}
    </li> : null;
}
const sx = {
  listItem: {
    kVAEAm: "x1n2onr6",
    kmVPX3: "x1717udv",
    kB88ic: "xe8uvvx",
    k1xSpc: "xrvj5dj",
    kumcoG: "x4w6khx",
    k9llMU: "x1clt5hq",
    kBCFzs: "x623te4",
    kbNqZ1: "x1c4oqta",
    kOIVth: "xxhr3t",
    $$css: true
  },
  textOnlyStyles: {
    kumcoG: "x1y6fwsi",
    $$css: true
  }
};
const largeCardStyles = {
  listItem: {
    kaIpWk: "x1o5z2k8",
    $$css: true
  }
};